import React, { useContext, useEffect, useState } from 'react'
import { ShippingMethodSelector, Spinner, GenericModal } from '@pinflag/pinflag-ui-kit'
import { DataContext } from '../../context/DataContext'
import { useApiPinflag } from '../../hook/useApiPinflag'
import { CHANGE_ORDER, STORES_WITH_CLICK_AND_COLLECT_DISCOUNT } from '../../constants/stores'
import AddressTypeInputSelector from './AddressTypeInputSelector'
import PickupMap from './PickupMap'
import { HOME_DELIVERY, PICKUP_POINT } from '../../constants/deliveryTypes'
import { useShopify } from '../../hook/useShopify'

const ShippingOptionRenderer = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingShopify, setIsLoadingShopify] = useState(true)
  const {
    steps,
    setSteps,
    pointsData,
    selectedShippingMethod,
    setSelectedShippingMethod,
    setIsPickup,
    companyInfo,
    cartData,
    isProductSoldOut,
    setIsProductSoldOut,
    ecommerceInfo
  } = useContext(DataContext)
  const {
    redirectToCartShopify
  } = useShopify()
  const { primaryColor, secondaryColor, companyName } = companyInfo
  const { getPoints } = useApiPinflag()
  const { localPoints, pinflagPoints } = pointsData
  const areDisabled = {
    localPickup: !localPoints.length,
    cnc: !pinflagPoints.length,
    homeDelivery: false
  }
  const badge = {
    localPickup: companyInfo.storePickupPriceLabel,
    cnc: companyInfo.ccDiscountPercentageLabel,
    homeDelivery: ''
  }
  const buttonsTitle = {
    localPickup: 'Retiro en ' + companyInfo.storePickupTypeLabel,
    cnc: PICKUP_POINT,
    homeDelivery: HOME_DELIVERY
  }

  const handleClick = option => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    setSteps(updatedSteps)
    setSelectedShippingMethod(option)
  }

  const redirection = () => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    setSteps(updatedSteps)
    setSelectedShippingMethod('home-delivery')
  }

  useEffect(() => {
    setIsPickup(false)
    const isGiftCardProduct = cartData.lines.every(item => {
      if (item.requires_shipping === undefined) return false

      if (!item.requires_shipping) return true

      return !item.requires_shipping
    })

    if (!localPoints.length && !pinflagPoints.length && !isGiftCardProduct) {
      getPoints(setIsLoading)
    } else {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!isLoading && areDisabled.cnc && areDisabled.localPickup) {
      redirection()
    }
  }, [isLoading])

  const reloadPoints = () => {
    setIsLoading(true)
    getPoints(setIsLoading)
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = false
    setIsPickup(false)
    setSelectedShippingMethod(null)
    setSteps(updatedSteps)
  }

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoadingShopify(false)
      }, 2000)
    }
  }, [isLoading])

  if (isLoading || (ecommerceInfo.cms === 'shopify' && isLoadingShopify)) {
    return (
      <div className='full_width_spinner md:w-[537px]'>
        <div className='md:flex md:justify-center'>
          <Spinner width={44} />
        </div>
      </div>
    )
  }

  const handleClose = () => {
    setIsProductSoldOut(false)
    redirectToCartShopify()
  }

  return (
    <>
    <GenericModal
      isOpenModal={isProductSoldOut}
      icon='error'
      modalTitle='Producto agotado'
      modalText='Uno de tus productos está agotado. Debes dirigirte al carro.'
      secondButton='Volver al carro'
      handleAction={handleClose}
    />
      {!selectedShippingMethod
        ? (
            <ShippingMethodSelector
              areDisabled={areDisabled}
              handleButtonClick={handleClick}
              companyName={companyName}
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              badge={badge}
              isCncDisabled={
                companyName === 'Opaline' ||
                companyName === 'Colloky' ||
                companyName === 'Safety Store B2B' ||
                companyName === 'Vielco'
              }
              isLocalPickupDisabled={
                companyName === 'Safety Store B2B' ||
                companyName === 'SELFIE'
              }
              cncSubtitle={companyName === 'Brando' ? '+300 puntos' : ''}
              buttonsTitle={buttonsTitle}
              changeOrder={CHANGE_ORDER.includes(companyName)}
              hideLeaf={companyName === 'Lorenzo di Pontti'}
              showDiscountBanner={
                STORES_WITH_CLICK_AND_COLLECT_DISCOUNT.includes(companyName)
              }
            />
          )
        : selectedShippingMethod === 'home-delivery' || selectedShippingMethod === 'unnecessary'
          ? (
            <AddressTypeInputSelector />
            )
          : (
            <PickupMap reloadPoints={reloadPoints} />
            )}
    </>
  )
}

export default ShippingOptionRenderer
